import React, { useState } from "react"
import useNotification from "src/features/Notification/customs"
import { useSelector, useDispatch } from "react-redux"
import { removeMedicineBundle, updateMedicineBundle } from "../ducks"

import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"

import Card from "./card"
import SearchMedicine from "./SearchProduct"

const Empty = () => (
  <Box mt={12} mb={3} textAlign="center">
    No package
    <Box color="text.secondary">
      Please, click button “Choose Medicine” for import the package in your
      bundle
    </Box>
  </Box>
)

function Index() {
  const dispatch = useDispatch()
  const { showSuccess } = useNotification()
  const [open, setOpen] = useState(false)
  const bundle_medicines = useSelector(
    (state) => state.bundle_create.bundle_medicines
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  // find index
  const findIndex = (_id) =>
    bundle_medicines.map((item) => item._id).indexOf(_id)

  const handleUpdateMedicine = (_id) => (amount) => {
    dispatch(updateMedicineBundle(findIndex(_id, "medicine"), amount))
    showSuccess()
  }

  const handleRemoveMedicine = (_id) => () => {
    dispatch(removeMedicineBundle(findIndex(_id, "medicine")))
    showSuccess()
  }

  return (
    <>
      <SearchMedicine isOpen={open} handleClose={handleClose} />
      <Box mt={2} mb={3}>
        {bundle_medicines.length} of Package
      </Box>
      {!bundle_medicines.length && <Empty />}

      <Box overflow="auto" whiteSpace="nowrap">
        <Box minWidth="1184px">
          {bundle_medicines.map((item) => (
            <Card
              key={item._id}
              item={item}
              update={handleUpdateMedicine(item._id)}
              remove={handleRemoveMedicine(item._id)}
            />
          ))}
        </Box>
      </Box>

      <Box textAlign="center" mt={3}>
        <Button variant="contained" disableElevation onClick={handleOpen}>
          Choose Medicine
        </Button>
      </Box>
    </>
  )
}

export default Index
